export const MNR_TENANT_ID = "b4b61b73-4f38-45a0-b460-7e38b2777479";
